// =============================================================================
// PG カートでの購入可否判定
// =============================================================================
async function PG_check_buyable(customer_id) {
  $('#PG_btn_CheckOut').prop('disabled', true);
  var cart_obj = await fetch_cart_items();
  var cart_items = cart_obj.items;
  var product_ids = cart_items.map(cart_item => cart_item.product_id);

  var headers = {
    'Accept': 'application/json',
    'Content-Type': 'application/json'
  };

  var request_body = JSON.stringify({
    customer_id: customer_id,
    product_ids: product_ids
  });

  display_loading();

  fetch('https://shopify.engineer.quickticket.moala.fun/api/v1/shopify_users/buyable',
    {
      method: 'POST',
      headers: headers,
      body: request_body
    }
  ).then(function (response) {
    if (response.ok) {
      return response.text();
    } else if (response.status == 422) {
      return response.json().then(function (error) {
        if (error.type == 'invalid_request_error' && error.code == 'unbuyable_products_are_contained') {
          // NOTE: error_messsageを1個ずつ取り出して、処理します
          display_buyable_error_messages(error);
        } else if (error.params == 'channel_not_found') {
          // NOTE: 商品のチャンネル設定を誤っている場合のエラー
          display_retry_message();
          throw Error('channel_not_found');
        } else if (error.type == 'invalid_request_error' && error.code == 'shopify_user_not_found') {
          display_retry_message();
          throw Error('User Not Found');
        } else {
          display_retry_message();
          throw Error('Something went wrong');
        }
      });
    } else {
      // TODO: ここどうすればよいか相談する
      display_retry_message();
      throw Error('Something went wrong');
    }
  }).then(function () {
    remove_loading();
    // NOTE: 成功時にチェックアウトへ遷移する
    display_checkout_page();
  }).catch(function (error) {
    disabled_button();
    scrollToTop();
    remove_loading();
  });
}

function display_checkout_page() {
  location.href = '/cart/checkout';
}

function fetch_cart_items() {
  var result = fetch('/cart.js').then(function (response) {
    if (response.status == 200) {
      return response.json();
    } else {
      return response.json().then(function(err){
        throw Error(err.message);
      });
    }
  }).then(function (data) {
    return data;
  }).catch(function () {
    return 'Error';
  });

  if (result != 'Error') {
    return result;
  }
}

function display_loading() {
  $('body').append("<div id='now_loading' class='loader'></div>");
}

function remove_loading() {
  $('#now_loading').remove();
}

function display_buyable_error_messages(error) {
  error.errors.forEach(error_body => {
    var product_id = error_body.product_id;
    var buyable_rank = error_body.buyable_rank;

    display_error_message_container(product_id);

    display_rank_error_message(buyable_rank, product_id);

    // NOTE: channel判定
    var channel_error = error_body.channel_error;
    var rest_channel_count = channel_error.rest_channel_count

    if (rest_channel_count != 0) {
      display_channel_error_message(channel_error, product_id, rest_channel_count);
    }
  });
  display_refresh_guide_message();
  throw Error(error);
}

function display_error_message_container(product_id) {
  // NOTE: カートアイテムの一覧のスタイルを書き換え、エラーメッセージを表示する
  $(`#item-row-${product_id}`).removeClass('cart__row-border-bottom-gray');
  $(`#buyable-error-container-${product_id}`).css({
    visibility: 'visible',
    display: ''
  });
}

function display_rank_error_message(buyable_rank, product_id) {
  // NOTE: 購入条件を満たすランクではない場合にエラーメッセージを出す
  if (buyable_rank == false) {
    $(`#cart__rank-error-${product_id}`).css('display', 'block');
  }
}

function display_channel_error_message(channel_error, product_id, rest_channel_count) {
  var min_join_count = channel_error.min_join_count;
  var required_channels = channel_error.channels;
  var required_channel_count = required_channels.length;

  // NOTE: チャンネルエラーメッセージのタイトルを生成
  if (required_channel_count == 1) {
    var cart_error_msg = '以下のチャンネルにご入会ください。';
  } else if (required_channel_count == min_join_count) {
    var cart_error_msg = `以下から、"全て"のチャンネルにご入会ください。`;
  } else {
    var cart_error_msg = `以下から、"${min_join_count}つ以上"のチャンネルにご入会ください。`;
  }

  // NOTE: 購入条件のチャンネルに一つ以上加入している場合
  if (min_join_count != rest_channel_count ) {
    cart_error_msg = `${cart_error_msg}（残り"${rest_channel_count}つ"）`
  }

  $(`#channel-error-title-${product_id}`).html(cart_error_msg);

  display_required_channel_list(required_channels, product_id);
}

function display_required_channel_list(required_channels, product_id) {

  var joining_list = $(`#joining-channel-list-${product_id}`);
  joining_list.css('display', 'block');

  // NOTE: 未加入チャンネルのチャンネル名リストを作成する
  for (var i = 0; i < required_channels.length; i++) {
    var channel_id = required_channels[i].channel_id;
    var channel_name = required_channels[i].channel_name;


    if (required_channels[i].is_joined) {
      var error_text_ele = $('<div>', {class: 'cart__channel-joined-text', text: channel_name})
      var error_tag_ele = $('<div>', {class: 'cart__channel-joined-tag', text: '入会済'})
      var error_message_flexbox = $('<div>', {class: 'cart__channel-joined-flexbox'}).append(error_text_ele).append(error_tag_ele);
      var error_message_ele = $('<li>').append(error_message_flexbox)
    } else {
      //  NOTE: channel登録のlinkを生成
      var error_link_ele = $('<a>', {
        class: 'cart__channel-join-link',
        href: `https://ch.nicovideo.jp/ch${channel_id}/join?return_url=${encodeURIComponent(document.URL)}&sec=dwticket&sub=${product_id}`,
        text: channel_name
      });
      var error_message_ele = $('<li>').append(error_link_ele);
    }

    joining_list.append(error_message_ele);
  }
}

function display_refresh_guide_message() {
  // NOTE: ボタン上部にページリフレッシュを促す文言を表示
  $('#page-refresh-guide').css('display', 'block');
}

function disabled_button() {
  $('#PG_btn_CheckOut').css({
    backgroundColor: '#7A7A7A',
    cursor: 'text',
    marginTop: '16px'
  });
}

function display_retry_message() {
  $('#buyable-top-error-message').css('display', 'block');
  scrollToTop();
}

function scrollToTop() {
  window.scrollTo(0, 0);
}

// カート内の商品をクリア
function clear_cart_items() {
  fetch("/cart/clear", {method: 'post'})
  .then((res)=> res).catch(console.error);
}

// カート内指定product_idの商品を削除
async function remove_cart_items(variant_id) {
  var params = "updates[" + String(variant_id) + "]=0";
  jQuery.post('/cart/update.js', params);
}


async function remove_cart_item_with_no_product_id() {
  var res = await fetch_cart_items();
  var params = {};

  res.items.forEach(item => {
    if (item.product_id === null) {
      jQuery.post('/cart/update.js', {updates: params});
    }
  })
}
